export default __webpack_public_path__ + "static/1-e863b5475178351a4755e97c9394fc1e.jpeg";